import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { WorksheetBaseProps } from 'html-worksheets/@types';
import PageLines from '../@common/PageLines';
import BaseInput from '../@common/BaseInput';
import LandscapePaperLayout from '../@common/landscape/LandscapePaperLayout';
import { translate } from '../../translations/translator';

const t = key => translate('worksheet', key);

type MyPictureProps = WorksheetBaseProps & {
  isOneLine?: boolean;
  noFooterText?: boolean;
  printRef?: React.RefObject<HTMLDivElement>;
};

const MyPicture = ({ onChange, isOneLine, valueMap, noFooterText, printRef }: MyPictureProps) => {
  const fontSize = isOneLine ? 100 : 65;

  const classes = useStyles({ isOneLine });

  const handleChange = ({ target }) => {
    const singleInputKey = 1;
    onChange({
      [singleInputKey]: target.value
    });
  };

  return (
    <LandscapePaperLayout noFooterText={noFooterText} printRef={printRef}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-evenly"
        flex={1}
        style={{ marginTop: isOneLine ? '-55px' : '-30px' }}
      >
        <Typography
          variant="h1"
          style={{
            display: 'flex',
            alignSelf: 'center',
            justifyContent: 'center',
            fontFamily: 'FF-HWTFuturaBold',
            fontSize: 20,
            paddingBottom: isOneLine ? 40 : 20
          }}
        >
          {isOneLine ? t('MYPICTURE') : t('myPicture')}
        </Typography>
        <Box style={{ display: 'flex', justifyContent: 'center' }}>
          <Box className={classes.box} />
        </Box>
        <PageLines
          style={{
            textAlign: 'center',
            paddingTop: isOneLine ? '75px' : '30px'
          }}
          width={900}
          isOneLine={isOneLine}
          isWide={!isOneLine}
          isExtraWide={isOneLine}
        >
          <BaseInput
            showBackground={true}
            onChange={handleChange}
            fontFamily="Print-Wide-Book"
            color="#767676"
            placeholder={t('myPicture')}
            fontSize={fontSize}
            className={classes.input}
            maxLength={60}
            value={valueMap[1]}
          />
        </PageLines>
      </Box>
    </LandscapePaperLayout>
  );
};
const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flex: 1
  },
  box: ({ isOneLine }: any) => ({
    border: '4px solid black',
    height: isOneLine ? '450px' : '500px',
    width: '900px'
  }),
  input: ({ isOneLine }: any) => ({
    width: '900px !important',
    marginTop: `${isOneLine ? '-103px' : '-48px'} !important`,
    color: 'black',
    display: 'flex',
    textAlign: 'center',
    letterSpacing: isOneLine ? 15 : 10,
    textTransform: isOneLine ? 'uppercase' : 'none'
  })
}));
export default MyPicture;
